import { BundleData, BundleSelection } from '../types';

export const getStudentBundleSelections = (
  bundleData?: BundleData,
): BundleSelection[] => Object.values(bundleData?.selections ?? {});
